import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  static values = {
    exitConfirmation: String
  }

  connect() {
    this.formChanged = false
    this.formTarget.addEventListener('input', this.handleFormChange.bind(this))
    this.formTarget.addEventListener('submit', this.handleFormSubmit.bind(this))
    document.addEventListener('click', this.handleExternalClick.bind(this))
  }

  disconnect() {
    this.formTarget.removeEventListener('input', this.handleFormChange.bind(this))
    this.formTarget.removeEventListener('submit', this.handleFormSubmit.bind(this))
    document.removeEventListener('click', this.handleExternalClick.bind(this))
  }

  handleFormChange() {
    this.formChanged = true
  }

  handleFormSubmit() {
    this.formChanged = false
  }

  handleExternalClick(event) {
    if (!this.formChanged) return;
    const target = event.target
    const generateDocumentFrame = document.getElementById('generate_document_frame')
    if (this.formTarget.contains(target) && !generateDocumentFrame?.contains(target)) return;

    const confirmation = confirm(this.exitConfirmationValue)
    if (!confirmation) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }

    this.formChanged = false
  }
}
